import { Pipe, PipeTransform } from '@angular/core';
import { UploadObj } from '../../classes/upload-obj.class';

@Pipe({
  name: 'uploadOrder',
  standalone: true,
})
export class UploadOrderPipe implements PipeTransform {
  transform(uploads: UploadObj[]): UploadObj[] {
    const now = Date.now();
    const list = [
      ...uploads.filter(upload => upload.status === 'done' && now - upload.timings.finished_at < 250),
      ...uploads.filter(upload => upload.status === 'started'),
      ...uploads.filter(upload => upload.status === 'waiting'),
      ...uploads.filter(upload => upload.status === 'processing'),
    ];

    return list.slice(0, 4);
  }
}
